import { useBloomreachPageModels } from "./use-bloomreach-page-models.js";
import { useSubscribeNewsletter } from "./use-subscribe-newsletter.js";
import { useBrPageContext } from "../../context/context/context.js";
import { getBrPageContent } from "../../utils/utils/get-br-page-content.js";
const useBloomreachNewsletterV2Data = () => {
  const newsletterSubscribe = useSubscribeNewsletter();
  const page = useBrPageContext();
  const pageModels = useBloomreachPageModels();
  const newsletterContent = getBrPageContent(
    page,
    pageModels?.newsletterV2Configuration
  );
  if (!newsletterContent) {
    return void 0;
  }
  const successHeader = newsletterContent?.successHeader;
  const signupHeader = newsletterContent?.signupHeader;
  const backgroundColor = newsletterContent?.backgroundColor;
  const consent = newsletterContent?.consent?.value;
  return {
    ...newsletterSubscribe,
    backgroundColor,
    consent,
    signupHeader,
    successHeader
  };
};
export {
  useBloomreachNewsletterV2Data
};
//# sourceMappingURL=use-bloomreach-newsletter-v2-data.js.map
